export function convertToSlug (Text) {
    return Text
        .toLowerCase()
        .replace(/ /g, '-')
        .replace(/,/g, '-')
        .replace(/\./g, '-')
        .replace(/\+/g, '-plus')
        .replace(/[^\w-]+/g, '')
    ;
}



// WEBPACK FOOTER //
// ./app/bundles/enterprise-shop/src/api/utils/convert-to-slug.ts